import { setWidgetStatus, setWidgetVisibility } from '../../../actions/layout';
import { selectTransactionId, selectPaymentAmount, selectPaymentInitSource } from '../../../selectors/checkout';
import { selectIsModal } from '../../../selectors/layout';
import { getYooKassaConfirmationToken } from '../../../services/yooKassa/getYooKassaConfirmationToken';
import { TThunkAction } from '../../../types/redux';
import { EWidgetStatus } from '../../../types/redux/layout';
import { openYooKassaWidgetThunk } from '../openYooKassaWidget';

export const payByYooKassaThunk: TThunkAction = async (dispatch, getState, { httpApi }) => {
  const state = getState();
  const transactionId = selectTransactionId(state);
  const amount = selectPaymentAmount(state);
  const paymentInitSource = selectPaymentInitSource(state);
  const isModal = selectIsModal(state);

  const token = await getYooKassaConfirmationToken({ httpApi, amount, transactionId, paymentInitSource });

  if (isModal) {
    dispatch(setWidgetVisibility(false));
  } else {
    dispatch(setWidgetStatus(EWidgetStatus.Ready));
  }

  dispatch(openYooKassaWidgetThunk({ token }));
};
